import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { SellerFlexPage } from '@/components/SellerFlex/SellerFlexPage'
import { listSearchSchema, withoutListDefaults } from '@/components/common/listSearch'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the shared list page. */
export const Route = createFileRoute('/_app/operations/seller-flex-stock/')({
  validateSearch: listSearchSchema,
  component: SellerFlexStockRoute,
})

function SellerFlexStockRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <SellerFlexPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutListDefaults, next, options))
      }
    />
  )
}
